import { UserAccountType } from "@common/constants/UserAccountType";

export const ONLINE_USER_WALLETS = new Set([
	UserAccountType.SportBettingAccountOnline,
	UserAccountType.CasinoAccount,
	UserAccountType.LiveCasinoAccount,
	UserAccountType.Games,
]);
